<template>
  <form
    autocomplete="off"
    class="gap-0 gap-y-4 "
    @submit.prevent="submitForm"
  >
    <div class="col-span-12 mx-auto text-center w-full">
      <h2>
        Edit Price
      </h2>

      <TextInput
        v-model="formData.price"
        label="Price"
        class="mb-8"
        :validation-error="errors && 'price' in errors && errors.price[0]"
        autofocus
      />

      <div class="flex gap-3">
        <AppButton
          :disabled="processing"
          class="btn btn-outline btn-secondary py-2.5 w-full"
          @click="$emit('close')"
        >
          Cancel
        </AppButton>

        <AppButton
          :processing="processing"
          class="btn btn-solid btn-secondary py-2.5 w-full"
        >
          {{ processing ? 'Confirming' : 'Confirm' }}
        </AppButton>
      </div>
    </div>
  </form>
</template>

<script setup>
import { reactive } from 'vue';

import { AppButton } from '@/components/app';
import { TextInput } from '@/components/forms/inputs';

const emit = defineEmits(['close', 'confirm']);

const props = defineProps({
  price: {
    type: Object,
    default: () => {},
  },
  errors: {
    type: Object,
    default: () => {},
  },
  processing: Boolean,
});

const formData = reactive({
  price: props.price?.price,
  type: props.price?.type,
  style: props.price?.style,
  delivery: props.price?.delivery,
  size: props.price?.size,
});

const submitForm = () => {
  if (!props.processing) {
    emit('confirm', formData);
  }
};

</script>
